module.exports = __webpack_public_path__ + "img/ELA.6e36d58c.png";